document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('.hamburger');
    const navbar = document.querySelector('.navbar-default');
    const body = document.body;
    const mediaQuery = window.matchMedia('(min-width: 1024px)');

    if (!toggle || !navbar) {
        return;
    }

    // Mobile menu toggle
    toggle.addEventListener('click', (e) => {
        e.preventDefault();

        toggle.classList.toggle('is-active');
        navbar.classList.toggle('is-active');
        body.classList.toggle('no-scroll');
    });

    // Dropdown handler
    navbar.addEventListener('click', (e) => {
        // Only run in mobile (< 1024px)
        if (mediaQuery.matches) {
            return;
        }

        const button = e.target.closest('.dropdown-button');
        if (!button) {
            return;
        }

        e.preventDefault();
        button.classList.toggle('active');
    });

    // Reset dropdown state when switching to desktop
    mediaQuery.addEventListener('change', (mq) => {
        if (!mq.matches) {
            return;
        }

        navbar
            .querySelectorAll('.dropdown-button.active')
            .forEach((btn) => btn.classList.remove('active'));
    });
});
